import request from '@/utils/httpRequest'

export default class PropertyService {
    queryById (id) {
        return request({
            url: '/shye/base/shyeProperty/queryById',
            method: 'get',
            params: {id: id}
        })
    }

    startFlow (params) {
        return request({
            url: '/shye/base/shyeProperty/startFlow',
            method: 'post',
            data: params
        })
    }
}
